export default {
  namespaced: true,

  state: () => ({
    products: {
      data: [],
      links: {},
      meta: {},
    },
    isLoading: false,
  }),

  mutations: {
    SET_PRODUCTS(state, payload) {
      state.products = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getProducts({ commit }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)

        const url = `/v1/admin/products?filter[is_verified]=false&sort=-created_at&filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_PRODUCTS', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async approveProduct({ commit, dispatch }, { id, status }) {
      try {
        const url = `v1/admin/products/approval/${id}`

        const response = await this._vm.$http.put(url, { is_verified: status })

        dispatch('getProducts')

        commit('response/SET_SUCCESS', {
          message: status ? 'Produk Berhasil Di-approve!' : 'Produk Telah Di-reject!',
        }, { root: true })
        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Error!',
        }, { root: true })
        return error
      }
    },
  },
}
